const s = {
  name: "EndlessAisle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,8.5C0,3.8,3.8,0,8.5,0C13.2,0,17,3.8,17,8.5V15h14.5c3.6,0,6.5-2.9,6.5-6.5C38,4.9,35.1,2,31.5,2
			S25,4.9,25,8.5V12h-2V8.5C23,3.8,26.8,0,31.5,0S40,3.8,40,8.5c0,4.7-3.8,8.5-8.5,8.5H25v14.5c0,3.6,2.9,6.5,6.5,6.5
			s6.5-2.9,6.5-6.5S35.1,25,31.5,25H28v-2h3.5c4.7,0,8.5,3.8,8.5,8.5S36.2,40,31.5,40S23,36.2,23,31.5V25H8.5C4.9,25,2,27.9,2,31.5
			S4.9,38,8.5,38c3.6,0,6.5-2.9,6.5-6.5V28h2v3.5c0,4.7-3.8,8.5-8.5,8.5C3.8,40,0,36.2,0,31.5S3.8,23,8.5,23H15V8.5
			C15,4.9,12.1,2,8.5,2C4.9,2,2,4.9,2,8.5C2,12.1,4.9,15,8.5,15H12v2H8.5C3.8,17,0,13.2,0,8.5z M17,17v6h6v-6H17z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EndlessAisle
};
